import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

export const BlockManualContent: Definition = {
  contentType: 'BlockManualContent',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol'
    },
    {
      id: 'contentBlock1Text',
      name: 'Content Block 1 - Text',
      type: 'RichText'
    },
    {
      id: 'contentBlock1Media',
      name: 'Content Block 1 - Media',
      type: 'ModuleMedia'
    },
    {
      id: 'contentBlock2Text',
      name: 'Content Block 2 - Text',
      type: 'RichText'
    },
    {
      id: 'contentBlock2Media',
      name: 'Content Block 2 - Media',
      type: 'ModuleMedia'
    }
  ]
}

export const PageManuals: Definition = {
  contentType: 'PageManuals',
  fields: [
    {
      id: 'manuals',
      name: 'Manuals',
      type: 'Array',
      subType: 'BlockMediaCardGroup',
      validations: [{ size: { min: 0, max: 8 } }],
      imageOptions: { sizes: imageSizes.columns3_11 }
    }
  ]
}

export const PageManualsDetail: Definition = {
  contentType: 'PageManualsDetail',
  fields: [
    {
      id: 'heroEyebrow',
      name: 'Eyebrow',
      type: 'Text',
      localized: true
    },
    {
      id: 'downloadPdf',
      name: 'Download PDF',
      type: 'ModuleMedia'
    },
    {
      id: 'blockManualContent',
      name: 'Content Blocks',
      type: 'Array',
      subType: 'BlockManualContent',
      validations: [{ size: { min: 0, max: 8 } }]
    }
  ]
}

export default {
  BlockManualContent,
  PageManuals,
  PageManualsDetail
}
